import React from 'react';

function MinimalFooter() {
  return (
    <footer style={{
      padding: '16px 20px',
      textAlign: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        color: 'rgba(255, 255, 255, 0.4)',
        fontSize: '12px',
        fontWeight: '400'
      }}>
        © 2026 SudokuMatch
      </div>
    </footer>
  );
}

export default MinimalFooter;
